export const ISSUE_VIEW_END_USERS_CROSS_FLOW_VIA_E2E_ANALYTICS_KEY =
	'issueViewEndUsersCrossFlowViaE2EExperiment';
export const ISSUE_VIEW_END_USERS_CROSS_FLOW_VIA_E2E_EXPERIMENT_KEY =
	'issue_view_end_users_cross-flow_via_e2e_flow';
